export enum MeasurementType {
    Typenschild = 0,
    VisualInspection = 4,
    WindingResistance = 5,
    PoleImpedance = 6,
    IsolationImpedanceStator = 7,
    IsolationImpedanceRotor = 8,
    LossFactor = 9,
    PartialDischarge = 10,
    VoltageTesting = 11,
    InductionTesting = 12,
    HeatingTest = 13,
    Vibrations = 14,
}

export const MeasurementTypes: ReadonlyArray<{ labelKey: string; value: MeasurementType; tableSections?: Record<number, string>; }> = [
    {
        labelKey: 'generators.conditionStatus.content.measurements.typenschild.title',
        value: MeasurementType.Typenschild,
    },
    {
        labelKey: 'generators.conditionStatus.content.measurements.windingResistance.title',
        value: MeasurementType.WindingResistance,
    },
    {
        labelKey: 'generators.conditionStatus.content.measurements.poleImpedance.title',
        value: MeasurementType.PoleImpedance,
        tableSections: {
            0: 'generators.conditionStatus.content.poleNumber',
            1: 'generators.conditionStatus.content.maxDeviationFromMean',
        }
    },
    {
        labelKey: 'generators.conditionStatus.content.measurements.isolationImpedanceStator.title',
        value: MeasurementType.IsolationImpedanceStator,
        tableSections: {
            0: 'generators.conditionStatus.content.results',
            1: 'generators.conditionStatus.content.linearDeviation',
            2: 'generators.conditionStatus.content.time',
        }
    },
    {
        labelKey: 'generators.conditionStatus.content.measurements.isolationImpedanceRotor.title',
        value: MeasurementType.IsolationImpedanceRotor,
        tableSections: {
            0: 'generators.conditionStatus.content.time',
            1: 'generators.conditionStatus.content.cx',
            2: 'generators.conditionStatus.content.linearDeviation',
        }
    },
    {
        labelKey: 'generators.conditionStatus.content.measurements.lossFactor.title',
        value: MeasurementType.LossFactor,
        tableSections: {
            3: 'generators.conditionStatus.content.characteristicSizes',
            4: 'generators.conditionStatus.content.testerAssessment'
        }
    },
    {
        labelKey: 'generators.conditionStatus.content.measurements.partialDischarge.title',
        value: MeasurementType.PartialDischarge,
        tableSections: {
            0: '',
            1: 'generators.conditionStatus.content.testerAssessment',
        }
    },
    {
        labelKey: 'generators.conditionStatus.content.measurements.voltageTesting.title',
        value: MeasurementType.VoltageTesting,
    },
    {
        labelKey: 'generators.conditionStatus.content.measurements.inductionTesting.title',
        value: MeasurementType.InductionTesting,
        tableSections: {
            0: 'generators.conditionStatus.content.hotspot'
        }
    },
    {
        labelKey: 'generators.conditionStatus.content.measurements.heatingTest.title',
        value: MeasurementType.HeatingTest,
        tableSections: {
            0: 'generators.conditionStatus.content.time'
        }
    },
    {
        labelKey: 'generators.conditionStatus.content.measurements.vibrations.title',
        value: MeasurementType.Vibrations,
        tableSections: {
            0: 'generators.conditionStatus.content.measurementName',
            1: 'generators.conditionStatus.content.testerAssessment',
        }
    },
]
